import type {SearchQueryResponseData} from '../queries/searchQuery';

/* @flow */
export const SEARCH_QUERY_COMPLETE = 'SEARCH_QUERY/COMPLETE';

type SearchQueryCompleteActionType = 'SEARCH_QUERY/COMPLETE';

type SearchQueryCompleteAction = {
    type: SearchQueryCompleteActionType,
    payload: SearchQueryResponseData
};

export type Action = SearchQueryCompleteAction;

const ACTION_CREATORS = {
    searchQueryComplete(
        data: SearchQueryResponseData
    ): SearchQueryCompleteAction {
        return {
            type: SEARCH_QUERY_COMPLETE,
            payload: data
        };
    }
};

export default {...ACTION_CREATORS};
